import React from 'react'
import { Tooltip, IconButton, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import BuildIcon from '@mui/icons-material/Build';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SummarizeIcon from '@mui/icons-material/Summarize';
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import CustomerEditButton from '../CustomerEditTable/CustomerEditButton';

function CustomerButton({ rows, setRows, params, firstRow, field}) {

  const navigate= useNavigate()
  const addRow = () => {
    console.log(rows);
    const lastRow = rows[rows.length - 1];
    if (!lastRow || lastRow[field] === '') {
      alert('Please fill in all fields before adding a new row.');
      return;
    }     
    if (rows.slice(0, rows.length - 1).some((row) => row[field] === lastRow[field])) {
      alert('Item already added.');
      return;
    }    
    const newRow = { ...firstRow, id: rows.length+1 };
    setRows([...rows, newRow]);
};

const deleteRow = (id) => {
    if (rows.length > 1) {
        const updatedRows = rows.filter((row) => row.id !== id);
    
        const updatedRowsWithConsecutiveIDs = updatedRows.map((row, index) => ({
          ...row,
          id: index + 1,
        }));
    
        setRows(updatedRowsWithConsecutiveIDs);
      } 
};

 

  return (
    <Stack direction="row" spacing={1}>
      <Tooltip title="Estimate">
        <IconButton
          sx={{
            color: "#489C8F",
            "&:hover": { backgroundColor: "#df9797", color: "white" },
          }}
          onClick={() => navigate("/estimate")}
        >
          <SummarizeIcon sx={{ fontSize: "20px" }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Service Order">
        <IconButton
          sx={{
            color: "#0066b2",
            "&:hover": { backgroundColor: "#88a3c9", color: "white" },
          }}
          size="small"
          onClick={() => navigate("/service_Order")}
        >
          <BuildIcon sx={{ fontSize: "20px" }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Invoice">
        <IconButton
          sx={{
            color: "#212121",
            "&:hover": { backgroundColor: "#df9797", color: "white" },
          }}
          onClick={() => navigate("/Invoice")}
        >
          <ReceiptIcon sx={{ fontSize: "20px" }} />
        </IconButton>
      </Tooltip>
      <CustomerEditButton/>
      {/* <Tooltip title="Remove">
        <IconButton
          size="small"
          onClick={() => {
            deleteRow(params.row.id);
          }}
        >
          <RemoveCircleOutlinedIcon sx={{fontSize: "20px", color: "#CD5C5C" }} />
        </IconButton>
      </Tooltip>
      {params.row.id === rows.length && (
        <Tooltip title="Update">
          <IconButton
            size="small"
            onClick={() => {
              addRow();
            }}
          >
            <AddCircleOutlinedIcon sx={{fontSize: "20px", color: "green" }} />
          </IconButton>
        </Tooltip>
      )} */}
    </Stack>
  );

}

export default CustomerButton